import { MailboxType } from 'owa-client-ids';
import { ClientItem } from 'owa-mail-store';

export default function isGroupItem(clientItem: ClientItem): boolean {
    return clientItem.MailboxInfo && clientItem.MailboxInfo.type === MailboxType.GroupMailbox;
}
